import { Card, Col, Row } from 'antd';
import { useField } from 'formik';
import { useTranslation } from 'react-i18next';
import FormFields from '../../../../themes/admin/Fields/FormFields';
import useSystemSwitchData from '../../../../utilities/useSystemSwitchData';
import PackageSettingFieldGroup from './PackageSettingFieldGroup';

const PackageBlockForm = ({ disabled = false }: { disabled?: boolean }) => {
    const { t } = useTranslation(['variantConfiguratorDetails']);

    const { yesNoSwitch } = useSystemSwitchData();

    const [field] = useField<boolean>('packageBlockInput.isActive');

    return (
        <>
            <Card>
                <Row gutter={14}>
                    <Col lg={12} xs={24}>
                        <FormFields.SwitchField
                            {...yesNoSwitch}
                            {...t('variantConfiguratorDetails:fields.packages.isActive', { returnObjects: true })}
                            disabled={disabled}
                            name="packageBlockInput.isActive"
                        />
                    </Col>
                </Row>
            </Card>
            {field.value && <PackageSettingFieldGroup disabled={disabled} />}
        </>
    );
};

export default PackageBlockForm;
